/** When your routing table is too long, you can split it into small modules**/

const commonRoutes = [
    {
        path: 'home',
        name: 'home',
        component: () => import('@/views/layout/Home'),
        meta: { menuName: 'exhi' }
    },
    {
        path: 'nopermission',
        name: 'nopermission',
        component: () => import('@/views/layout/NoPermission.vue')
    },
    {
        path: 'exhi/:params?',
        name: 'exhi',
        component: () => import('@/views/layout/Exhi'),
        meta: {
            menuset: false,
            exhiHome: true,
            menuName: 'exhi',
            overvisable: true
        }
    },
    {
        path: 'toHelp',
        name: 'toHelp',
        component: () => import('@/views/resources_config/exhiConfig/toHelp.vue')
    }

]

export default commonRoutes
